import { useEffect } from 'react';

import withAuth from 'hocs/withAuth/withAuth';
import { FormattedMessage } from 'react-intl';

import useComplaintDevice from 'hooks/useComplaintDevice';
import { SpecialistRole } from 'services/specialist';

import {
  PageHeader,
  AgendaTabList,
  OccasionalAvailabilityCard,
  HideCPCard,
} from 'components';
import RecurrentAvailabilityCard from 'components/RecurrentAvailabilityCard';

import * as S from './styles';

const CareProviderAgendaAvailability: React.FC = () => {
  const { handleSetComplaintDevice, isComplaintDevice } = useComplaintDevice();

  useEffect(() => {
    handleSetComplaintDevice(true);
  }, [handleSetComplaintDevice, isComplaintDevice]);

  return (
    <S.Container data-testid="availabilityPage">
      <PageHeader>
        <S.HeaderTitle data-testid="headerTitle">
          <FormattedMessage id="AGENDA.PAGE.TITLE" />
        </S.HeaderTitle>
      </PageHeader>
      <AgendaTabList selectedIndex={2} />
      <S.AvailabilityContainer data-testid="availabilityContainer">
        <RecurrentAvailabilityCard />
        <OccasionalAvailabilityCard />
        <HideCPCard />
      </S.AvailabilityContainer>
    </S.Container>
  );
};

export default withAuth(CareProviderAgendaAvailability, [SpecialistRole.CP]);
